import request from '../../services/request'

const api = {
  async verify(token) {
    const result = await request(`/users/activation/verification?token=${token}`)

    return result.response.token
  }
}

export default api
